import { useMutation, useQueryClient } from 'react-query'
import { AxiosError } from 'axios'
import commandBusAPI, { MomiOfflineError } from '../service/commandBusAPI'
import { SendCommandResponse } from '../types/commandBus.types'

export interface SendCommandArgs {
  devEui: string
  commandName: string
  params: Record<string, unknown>
}

export const useSendCommand = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    SendCommandResponse,
    AxiosError | MomiOfflineError,
    SendCommandArgs
  >({
    mutationFn: ({ devEui, commandName, params }) =>
      commandBusAPI.sendCommand(devEui, commandName, params),
    onSuccess: (_data, variables) => {
      // Invalide l'historique pour ce device afin que la nouvelle commande
      // (avec son status initial) apparaisse immédiatement dans la table.
      queryClient.invalidateQueries(['command-bus', 'history', variables.devEui])
    },
  })

  return mutation
}

export default useSendCommand
